import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';
import icons from '../../../config/styles/icons';
import { svgReplaceColor, svgToDataUri } from '../../../utils/styles/svgMixins';

const ModernLineDesktopStyles = css.global`
  /* Block: Modern PDP */
  .modern-pdp {
    background: ${colors.white.shade1};
  }

  /* Element: Main container */
  .modern-pdp__container {
    background-color: white;
    border-radius: 12px;
  }

  /* Element: Breadcrumbs container */
  .modern-pdp__breadcrumbs {
    margin-bottom: 4px;
  }

  /* Element: Content wrapper */
  .modern-pdp__content {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-start;
    gap: 32px;
  }

  /* Element: Tab container */
  .modern-pdp__tab {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* Element: Tab label */
  .modern-pdp__tab-label {
    margin: 0;
    font-weight: 500;
  }

  /* Element: Tab icons */
  .modern-pdp__tab-icon {
    min-width: 34px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    display: block;

    /* Modifier: Internet icon */
    &--internet {
      height: 30px;

      /* State: Active */
      &.modern-pdp__tab-icon--active {
        background-image: url('${svgToDataUri(svgReplaceColor(icons.onlyInternet, colors.green.shade1))}');
      }

      /* State: Disabled */
      &.modern-pdp__tab-icon--disabled {
        background-image: url('${svgToDataUri(svgReplaceColor(icons.onlyInternet, colors.gray.shade40))}');
      }
    }

    /* Modifier: Tienda icon */
    &--tienda {
      height: 22px;

      /* State: Active */
      &.modern-pdp__tab-icon--active {
        background-image: url('${svgToDataUri(svgReplaceColor(icons.tiendaIcon, colors.green.shade1))}');
      }

      /* State: Disabled */
      &.modern-pdp__tab-icon--disabled {
        background-image: url('${svgToDataUri(svgReplaceColor(icons.tiendaIcon, colors.gray.shade40))}');
      }
    }
  }

  /* Element: Image section */
  .modern-pdp__image-section {
    width: 62.5%;
    display: flex;
    flex-direction: column;
    gap: 20px;

    /* Modifier: Hardline layout */
    &--hardline {
      width: 55%;
    }
  }

  /* Element: Accordion container */
  .modern-pdp__accordion {
    /* Accordion styles will be handled by ProductSpecificationsAccordion component */
  }

  /* Element: Combo container */
  .modern-pdp__combo {
    /* Combo styles will be handled by ComboItemsDesktop component */
  }

  /* Element: Details section */
  .modern-pdp__details-section {
    display: flex;
    width: 37.5%;
    flex-direction: column;
    gap: 24px;
    position: sticky;
    top: 20px;
    align-self: flex-start;

    /* Custom scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: ${colors.gray.shade20} transparent;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${colors.gray.shade20};
      border-radius: 3px;

      &:hover {
        background-color: ${colors.gray.shade30};
      }
    }

    /* Modifier: Hardline layout */
    &--hardline {
      width: 45%;
    }
  }

  /* Element: Details header */
  .modern-pdp__details-header {
    /* Header styles will be handled by PDPBasicInfoDesktop component */
  }

  /* Element: Details body */
  .modern-pdp__details-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  /* Element: Seller ratings container */
  .modern-pdp__seller-ratings :global(.seller-ratings) {
    margin: 16px 0 0 0;
  }

  /* Legacy mobile details - keeping for compatibility */
  .basic-details-Mobile {
    display: flex;
    flex-direction: column;
    .reviews {
      display: flex;
      margin-top: 9px;
      &-column {
        position: relative;
        width: auto;
        display: flex;
      }
    }
    > div {
      margin-top: 15px;
      border: 1px solid red;
    }
    .corner-details {
      display: flex;
      justify-content: space-between;
    }
  }

  /* Element: Divider line */
  .modern-pdp__divider {
    box-sizing: border-box;
    height: 1px;
    width: 100%;
    border: 1px solid ${colors.gray.shade3};
    transform: scaleY(-1);
    margin: 16px 0;
  }

  /* Responsive Design */
  @media (max-width: 1024px) {
    .modern-pdp__content {
      flex-direction: column;
      gap: 20px;
    }

    .modern-pdp__image-section,
    .modern-pdp__image-section--hardline {
      width: 100%;
    }

    .modern-pdp__details-section,
    .modern-pdp__details-section--hardline {
      width: 100%;
      position: static;
      max-height: none;
      overflow-y: visible;
    }
  }

  @media (max-width: 768px) {
    .modern-pdp__content {
      gap: 16px;
    }

    .modern-pdp__details-body {
      gap: 12px;
    }
  }
`;

export default ModernLineDesktopStyles;
